// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oF-M","top":"styles_top__3DiD2"};